import { ALL_LANGUAGES, LANGUAGE_EN } from '~/utils/constants'

const STORAGE_KEY = 'locale'

export const isSupportedLanguage = language => ALL_LANGUAGES.includes(language)

export const setLanguage = (language) => {
  if (isSupportedLanguage(language)) {
    localStorage.setItem(STORAGE_KEY, language)
  }
}

export const getLanguage = defaultValue => mapToUiLanguage(localStorage.getItem(STORAGE_KEY)) || defaultValue

export const mapToApiLanguage = (language) => {
  switch (language) {
    case 'en-GB':
      return LANGUAGE_EN
    default:
      return language
  }
}

export const mapToUiLanguage = (language) => {
  switch (language) {
    case LANGUAGE_EN:
      return 'en-GB'
    default:
      return language
  }
}
